export interface FeedbackSurveyDef {
  key: string
  version: number
  label: string
  scaleMin: number
  scaleMax: number
  followupPrompt: string
}

export const GENERIC_FEEDBACK: FeedbackSurveyDef = {
  key: 'generic_feedback',
  version: 2,
  label: "How's your experience?",
  scaleMin: 1,
  scaleMax: 5,
  followupPrompt: 'Tell us more (optional)',
}

export const AUDIENCE_EXPERIENCE: FeedbackSurveyDef = {
  key: 'audience_experience',
  version: 1,
  label: 'How was setting up your audience?',
  scaleMin: 1,
  scaleMax: 5,
  followupPrompt: 'Tell us more (optional)',
}

export const STUDY_EXPERIENCE: FeedbackSurveyDef = {
  key: 'study_experience',
  version: 1,
  label: 'How was your study experience?',
  scaleMin: 1,
  scaleMax: 5,
  followupPrompt: 'Tell us more (optional)',
}

export const CHAT_EXPERIENCE: FeedbackSurveyDef = {
  key: 'chat_experience',
  version: 1,
  label: 'How was your chat experience?',
  scaleMin: 1,
  scaleMax: 5,
  followupPrompt: 'Tell us more (optional)',
}

export const FEEDBACK_SURVEYS: Record<string, FeedbackSurveyDef> = {
  generic_feedback: GENERIC_FEEDBACK,
  audience_experience: AUDIENCE_EXPERIENCE,
  study_experience: STUDY_EXPERIENCE,
  chat_experience: CHAT_EXPERIENCE,
}
